import React from "react";
import { Navigate } from "react-router-dom"; // Remove Route import

const AuthProtected = ({ children }) => {
  const getLoginStatus = localStorage.getItem("isLoggedIn") === "true";

  if (!getLoginStatus) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};

const AccessRoute = ({ component: Component, path, roles }) => {
  const userDetail = JSON.parse(localStorage.getItem("user")) || {}; // Parse user object

  if (roles.some( i => i == userDetail?.role)) {
    return <Component />;
  } else {
    return <Navigate to="/login" />
  }
  // if (
  //   userDetail?.role === "user" &&
  //   (path.startsWith("/user"))
  // ) {
  //   return <Navigate to="/data-curation" />;
  // } else if (userDetail?.role === "viewuser") {
  //   return <Navigate to="/fdf-master" />;
  // }
};

export { AuthProtected, AccessRoute };
